import React from 'react';
import styled from 'styled-components';
import { colors } from '../../settings';
import { Inline } from '../Inline';

export interface TextButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    color?: colors.Color;
    icon?: React.ReactNode;
    forwardedRef?: Exclude<React.ClassAttributes<HTMLButtonElement>['ref'], string>;
}
export function TextButton({
    className,
    children,
    color,
    icon,
    type = 'submit',
    forwardedRef,
    ...rest
}: TextButtonProps) {
    return (
        <StyledButton {...rest} className={className} color={color} type={type} ref={forwardedRef}>
            <Inline space="space6">
                {icon}
                <StyledLink color={color}>{children}</StyledLink>
            </Inline>
        </StyledButton>
    );
}

interface StyledButtonProps {
    color?: colors.Color;
}
const StyledButton = styled.button<StyledButtonProps>`
    display: inline-flex;
    line-height: inherit;
    cursor: pointer;
    background-color: transparent;
    background-image: none;
    font-family: inherit;
    padding: 0;
    border: none;

    :hover,
    :focus,
    :active {
        outline: none;

        span {
            border-color: ${(props) =>
                props.color ? colors[props.color] : colors.withAlpha(colors.typography.root, 80)};
        }
    }

    :disabled,
    [disabled],
    [aria-disabled='true'] {
        cursor: not-allowed;

        &,
        :hover,
        :focus,
        :active,
        span {
            border-color: ${colors.t1000};
            color: ${colors.pebbleBeach};
        }
    }
`;

interface StyledLinkProps {
    color?: colors.Color;
}
const StyledLink = styled.span<StyledLinkProps>`
    transition: border-color 0.15s ease-out;

    color: ${(props) => (props.color ? colors[props.color] : colors.typography.root)};
    border-bottom: solid 2px
        ${(props) =>
            props.color
                ? colors.withAlpha(colors[props.color], 50)
                : colors.withAlpha(colors.typography.root, 50)};
`;
